import { ViewController } from 'ionic-angular/navigation/view-controller';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';



@Component({
  selector: 'page-parametre-ayarlari',
  templateUrl: 'parametre-ayarlari.html',
})
export class ParametreAyarlariPage {
  param: any = {
    ID: "", PesinSatisHesabi: "", OnTanimKasa: "", FirmaAdi: "", FirmaTelefonu: "", FirmaAdres: "", FirmaEmail: "", FirmaWeb: "", FirmaVD: "",
    FirmaVN: "", DefaultSatisAlani: "", FisAciklama: "", SaticiDanismaniTakip: "", PuanOrani: "", BarkodlamaNo: "", SmsKullaniciAdi: "", SmsSifre: "", SmsGorunenAd: "",
    SatisSonrasiCariEkleme: "", SatisSirasindaStokMiktari: "", RiskAsimiKontrol: "", KasiyerCariTahsilatiYapsinMi: "", TeraziTuru: "", HitKontrol: "", PLUFiyatGoster: "",
    SatisUrunGrupla: "", AlisFiyatiniSonSatinalmadanAl: "", KasiyerStokGirsinMi: "", KasiyerFiyatDegistirsinMi: "", KasiyerVeresiyeSatsinMi: "", GununTarihi: "", FisNumarasiGoster: "",
    SiraNo: "", TeraziGoster: "",KullaniciStokEdit:"",OtomatikGuncelle:"", BuyukFisMi: "", SatisEkranindaParaUstuGoster: "", KasiyerStokAlabilsinMi: "",KullaniciSayimYapabilsinMi:"", KartliMusteri3FiyatUygulansin: "", MinPuanMiktari: "",BildirimGunSayisi:""
  };
  evethayir=[];

  cariListesi=[];
  kasaListesi=[];
  fisyaziciboyut=[];
  constructor(public navCtrl: NavController,
    public ortak: Ortak,
    public bllOrtak: BllOrtak,
    public viewCtrl: ViewController,
    public navParams: NavParams) {
      this.evethayir = [{
        "ID": "false",
        "Adi": "Hayır"
      },
      {
        "ID": "true",
        "Adi": "Evet"
      }
      ];
      this.fisyaziciboyut=[{
        "ID":"false",
        "Adi":"58mm"
      },
      {
        "ID":"true",
        "Adi":"80mm"
      }
    ];
  }

  ionViewDidLoad() {
    this.KasalariGetir();
    this.CarileriGetir();
    this.parametreleriGetir();
  }
  parametreleriGetir() {
    this.bllOrtak.islemWithoutPost("ParametreleriVer", "", false).then(a => {
      var sonuc = <any>a;
      this.param = sonuc.SonucObject;
      console.log("param",this.param)
     
    })
  }
  Kaydet()
  {
    var formdata=new FormData();
    formdata.append("ayar_json",JSON.stringify(this.param));
    this.bllOrtak.islem(formdata,"ParametreGuncelle","",true).then(a=>{
      var sonuc=<any>a;
      if(sonuc.Sonuc==1)this.ortak.showBasicAlert("Uyarı","Ayarlar Başarılı Bir Şekilde Güncellenmiştir");
      if(sonuc.Sonuc!=1)this.ortak.showBasicAlert("Uyarı","Beklenmedik Bir Hata Oluştu");
    })
  }
  KasalariGetir()
  {
    this.bllOrtak.islemWithoutPost("PerakendeKasaList", "", false).then(a => {
      var sonuc = <any>a;
      this.kasaListesi = sonuc.SonucObject;

    })
  }
  CarileriGetir()
  {
  
    this.bllOrtak.islemWithoutPost("ParamCariVer", "Yükleniyor", false).then(a => {
      var sonuc = <any>a;
      this.cariListesi = sonuc.SonucObject;
  })
}
}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/parametre-ayarlari/parametre-ayarlari.ts